import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

function IconNew({ size = 23, color = Config.BRAND_PRIMARY, className }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="18" height="18" rx="1" stroke={color} strokeWidth="1.5" fill="#0D0D0D"/>
      <path d="M12 8.25V15.75M15.75 12H8.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}


IconNew.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string
}

export default IconNew;
